import React from "react";

import {
  BarChart3,
  CalendarClock,
  LayoutDashboard,
  Rows3,
} from "lucide-react";

const VIEWS = [
  {
    key: "overview",
    label: "Vue d’ensemble",
    description:
      "Pilotage et priorités",
    icon: LayoutDashboard,
  },
  {
    key: "renewals",
    label: "Renouvellements",
    description:
      "Pipeline commercial",
    icon: CalendarClock,
  },
  {
    key: "forecast",
    label: "Prévisions",
    description:
      "12 prochains mois",
    icon: BarChart3,
  },
  {
    key: "contracts",
    label: "Tous les contrats",
    description:
      "Recherche et gestion",
    icon: Rows3,
  },
];

export default function SubscriptionsViewTabs({
  activeView,
  onChange,
  counts = {},
}) {
  return (
    <nav className="overflow-x-auto rounded-3xl border border-slate-200 bg-white p-2 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="flex min-w-max gap-2 lg:min-w-0 lg:grid lg:grid-cols-4">
        {VIEWS.map(
          (view) => {
            const Icon =
              view.icon;

            const isActive =
              activeView ===
              view.key;

            const count =
              Number(
                counts[
                  view.key
                ] || 0,
              );

            return (
              <button
                key={
                  view.key
                }
                type="button"
                onClick={() =>
                  onChange?.(
                    view.key,
                  )
                }
                className={[
                  "group flex min-w-[210px] items-center gap-3 rounded-2xl px-4 py-3 text-left transition lg:min-w-0",
                  isActive
                    ? "bg-slate-950 text-white shadow-md dark:bg-white dark:text-slate-950"
                    : "text-slate-600 hover:bg-slate-50 dark:text-slate-300 dark:hover:bg-slate-800",
                ].join(
                  " ",
                )}
              >
                <div
                  className={[
                    "grid h-10 w-10 shrink-0 place-items-center rounded-xl",
                    isActive
                      ? "bg-white/10 text-white dark:bg-slate-950/10 dark:text-slate-950"
                      : "bg-indigo-50 text-indigo-600 dark:bg-indigo-950/40 dark:text-indigo-300",
                  ].join(
                    " ",
                  )}
                >
                  <Icon
                    size={19}
                  />
                </div>

                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <p className="truncate text-sm font-black">
                      {
                        view.label
                      }
                    </p>

                    {count >
                      0 && (
                      <span
                        className={[
                          "rounded-full px-2 py-0.5 text-[11px] font-black",
                          isActive
                            ? "bg-white/15 text-white dark:bg-slate-950/10 dark:text-slate-950"
                            : "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300",
                        ].join(
                          " ",
                        )}
                      >
                        {
                          count
                        }
                      </span>
                    )}
                  </div>

                  <p
                    className={[
                      "mt-0.5 text-xs",
                      isActive
                        ? "text-slate-300 dark:text-slate-500"
                        : "text-slate-400",
                    ].join(
                      " ",
                    )}
                  >
                    {
                      view.description
                    }
                  </p>
                </div>
              </button>
            );
          },
        )}
      </div>
    </nav>
  );
}